import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Client, BodyParamsItem } from '../../../../../types/types';
import Service from '../../../../../services/bodyParams';
import DisplayBodyParamsByUserId from './DisplayBodyParamsByUserId';
import Collapsible from 'react-collapsible';
import PutBodyParam from '../../../../bodyParams/putBodyParam';

interface ClientDetailsProps {
    client?: Client; // Użyj opcjonalnego typu
}

const ClientBodyParams: React.FC<ClientDetailsProps> = ({ client }) => {
    const { t } = useTranslation('global');
    const [bodyParams, setBodyParams] = useState<BodyParamsItem[]>([]);
    const [allBodyParams, setAllBodyParams] = useState<BodyParamsItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const refreshData = () => {
        refreshBodyParams();
        refreshAllBodyParams(); 
    }

    const refreshAllBodyParams = () => {
        if (client) {
            Service.getAllBodyParamsByUserId(client.userId).then((response) => {
                setAllBodyParams(response.data || []);
            }).catch((error) => {
                console.log("Błąd podczas odświeżania allBodyParams:", error);
            });
        }
    };

    const refreshBodyParams = () => {
        if (client) {
            Service.getActualBodyParamsByUserId(client.userId).then((response) => {
                setBodyParams(response.data || []); // Upewnij się, że dane są tablicą
                setIsLoading(false);
            }).catch((error) => {
                console.log("Błąd podczas pobierania danych:", error);
                setIsLoading(false);
            });
        }
    }
    useEffect(() => {
        setIsLoading(true); // Dodaj to na początek!
        if (client?.userId) {
            Service.getActualBodyParamsByUserId(client.userId)
                .then((response) => {
                    setBodyParams(response.data || []);
                })
                .catch((error) => {
                    console.log("Błąd podczas pobierania danych:", error);
                })
                .finally(() => setIsLoading(false));
        } else if (client?.id) {
            Service.getActualBodyParamsByClientId(client.id)
                .then((response) => {
                    setBodyParams(response.data || []);
                })
                .catch((error) => {
                    console.log("Błąd podczas pobierania danych:", error);
                })
                .finally(() => setIsLoading(false));
        } else {
            setBodyParams([]);
            setIsLoading(false);
        }
    }, [client]);

    useEffect(() => {
        if (client?.userId) {
            Service.getAllBodyParamsByUserId(client.userId)
                .then((response) => {
                    setAllBodyParams(response.data || []);
                })
                .catch((error) => {
                    console.log("Błąd podczas pobierania danych:", error);
                });
        } else if (client?.id) {
            Service.getAllBodyParamsByClientId(client.id)
                .then((response) => {
                    setAllBodyParams(response.data || []);
                })
                .catch((error) => {
                    console.log("Błąd podczas pobierania danych:", error);
                });
        } else {
            setAllBodyParams([]);
        }
    }, [client]);

    if (!client) {
        return <div>{t('client_not_set')}</div>;
    }

    if (isLoading) {
        return <span className='loader' />;
    }

    return (
        <div>
            <ul>
                {Array.isArray(bodyParams) && bodyParams.map((item: BodyParamsItem, index: number) => (
                    <li key={index} id="bodyParams">
                        <Collapsible
                            trigger={
                                <div className="collapsible-element">
                                    <span>{item.dict_body_params_name}: {item.value}</span>
                                </div>
                            }
                        >
                            <DisplayBodyParamsByUserId
                                param_name={item.dict_body_params_name}
                                userId={client.userId}
                                allBodyParams={allBodyParams}
                                refresh={refreshAllBodyParams}
                            />
                        </Collapsible>
                    </li>
                ))}
                <PutBodyParam
                    clientId={client.id}
                    updateData={refreshData}
                />
            </ul>
        </div>
    );
};

export default ClientBodyParams;
